export const SET_PORTFOLIO_REPORT_ELEMENT_IDS = "SET_PORTFOLIO_REPORT_ELEMENT_IDS";
export function action_setPortfolio_Report_ElementIds(contract) {
	return { type: SET_PORTFOLIO_REPORT_ELEMENT_IDS, payload: contract };
}